import { Button } from '@mui/material';

export default function BottomSheetSecondaryButton({ children, onClick }) {
  return (
    <Button
      color="secondary"
      size="large"
      sx={{ mt: 3 }}
      fullWidth
      onClick={onClick}
    >
      {children}
    </Button>
  );
}
